export const RAW_MESSAGE_VIEW_OPEN_MODAL = "RAW_MESSAGE_VIEW_OPEN_MODAL";